 <button class="no-print" *ngIf="!ccview" mat-button (click)="print()"><mat-icon>print</mat-icon> Print </button>
<div id="print-section" #printSection *ngIf="service">
      
    <div id="{{service.id}}">
        <label id="s_name" class="srvc-name">
            <h2><span *ngIf="counter">{{counter}}.</span> {{service.serviceDetails.service_name}}</h2>
        </label>
    </div>
    <div>
        <p id="s_info" class="srvc-desc" [innerHtml]="sanitizeFormulafees(service.serviceDetails.service_description)"></p>
    </div>
    <table class="service-details">
        <col style="width:25%" />
        <col style="width:25%" />
        <col style="width:16%" />
        <col style="width:17%" />
        <col style="width:17%" />
        <tbody>
            <tr id="s_ood" class="header-details">
                <th>Office or Division:</th>
                <td colspan="4">
                    {{service.serviceDetails.process_owner?.name ? service.serviceDetails.process_owner.name :
                    service.serviceDetails.process_owner }}
                    <!--, <label class="my-tooltip" [matTooltip]="office?.name ? getJSONValue(office.offices) : office"
                        (click)="requirementservice.scrollto(office?.name ? office.name : office)"
                        *ngFor="let office of filterOfficeDivision(service.serviceDetails.process_owner,service.serviceDetails.office_division) ;let oindex = index;let c  = count">
                        {{office?.name ? office.name : office}}{{ (oindex < (c-1)) ? ' , ' : '' }}</label>
                            <span *ngIf="service.serviceDetails?.inter_agency_offices">, <span
                                    *ngFor="let inter_office of service.serviceDetails.inter_agency_offices;let iindex = index; let z = count ">
                                    {{inter_office}}{{ (iindex < (z-1))? ' , ' : '' }} </span>
                                </span> -->
                </td>

            </tr>
            <tr id="s_cat" class="header-details">
                <th>Category:</th>
                <td colspan="4">{{service.serviceDetails.service_category}}



                </td>

            </tr>
            <tr id="s_class" class="header-details">
                <th>Classification:</th>
                <td colspan="4">
                    {{service.serviceDetails.classification}}


                </td>

            </tr>
            <tr id="s_tot" class="header-details">
                <th>Type of Transaction:</th>
                <td colspan="4">{{service.serviceDetails.transactionTypeString}}


                </td>

            </tr>
            <tr id="s_wma" class="header-details">
                <th>Who may avail:</th>
                <td colspan="4">
                    <div [innerHtml]="service.serviceDetails.who_may_avail"></div>


                </td>

            </tr>
            <tr id="s_oh" class="header-details">
                <th>Operating Hours:</th>
                <td colspan="4">{{service.serviceDetails.operatingTime}}
                </td>

            </tr>
            <tr id="s_stt" class="header-details" *ngIf="service.serviceDetails.has_statute == true">
                <th>Statute:</th>
                <td colspan="4">
                    <div [innerHtml]="service.serviceDetails.statute"></div>


                </td>
            </tr>
            <tr *ngIf="reviewMode && service_effectivity != effectivity.DELIST">
                <td colspan="5">
                    <div class="container px-5">
                        <h4 *ngIf="openRemarks ">Service Information Remarks</h4>
                        <app-artemis-service-remarks-thread [openRemarks]="openRemarks" [remarks]=remarks_thread
                            [service_id]=service_id [component_id]="'Description'"
                            [type]="'description'"></app-artemis-service-remarks-thread>

                    </div>
                </td>
            </tr>

    <tr>
        <th colspan="2" class="text-center">CHECKLIST OF REQUIREMENTS</th>
        <th colspan="3" class="text-center">WHERE TO SECURE</th>
    </tr>

<!-- NO REQUIREMENTS PRESENT -->
<tr *ngIf="(!service.standardRequirements || service.standardRequirements.length === 0) && (!service.situationalRequirementsArray || service.situationalRequirementsArray.length === 0)">
  <td colspan="5">
    <p>No Requirements Needed.</p>
  </td>
</tr>

<!-- STANDARD REQUIREMENTS SECTION -->
<tr *ngIf="service.standardRequirements?.length > 0" > 
  <td colspan="5" >
    <!-- Label for this block -->
    <div class="section-header p-2 ms-3"><label class="pl-6">For Standard Requirement</label></div>
    <!--Nested table inside the requirement block -->
          <!-- Loop through each standard requirement -->
          <ng-container *ngFor="let req of service.standardRequirements; let i = index">
            <ng-container
              *ngTemplateOutlet="requirementTree; context: {
                $implicit: req,
                prefix: [requirementservice.printNumber(i)],
                depth: 1
              }"
            ></ng-container>
          </ng-container>
  </td>
</tr>

<!-- SITUATIONAL REQUIREMENTS SECTION -->
<tr *ngIf="service.situationalRequirementsArray?.length > 0">
  <td colspan="5">
    <!-- Label for this block -->
    <div class="section-header p-2 ms-3"><label class="pl-6">For Situational Requirement</label></div>
    <div class="content-center">
      <table class="requirement-table">
        <col style="width:50%" />
        <col style="width:50%" />
        <tbody>
          <ng-container *ngFor="let sit of service.situationalRequirementsArray; let i = index">
            <!-- Situation Header Row -->
            <tr [id]="'req_' + requirementservice.printLetter(i)">
              <td colspan="5">
                <div><b>{{ requirementservice.printLetter(i) }}. {{ sit.title }}</b></div>
                <!-- Requirements under Situation -->
                <ng-container *ngFor="let req of sit.requirement; let r = index">
                <ng-container
                    *ngTemplateOutlet="requirementTree; context: {
                    $implicit: req,
                    prefix: [requirementservice.printLetter(i), requirementservice.printNumber(r)],
                    depth: 2
                    }"
                ></ng-container>
                </ng-container>
              </td>
            </tr>
              <!-- Sub-Situational Requirements -->
                <tr *ngIf="sit.subRequirement?.length > 0">
                    <td colspan="5">
                          <div class="subsection-header"><label class="pl-6" style="font-style: italic;">Sub Situational Requirement/s</label></div>
                            <div class="content-center">
                            <table class="subsit-table">
                                <col style="width:50%" />
                                <col style="width:50%" />
                                <tbody>
                                     <ng-container *ngFor="let sub of sit.subRequirement; let subIndex = index">
                                        <!-- Sub Situation Title -->
                                      <tr [id]="'req_' + requirementservice.printLetter(i) + '.' + requirementservice.printLetterLower(subIndex)">
                                            <td colspan="5">
                                                <div><b>{{ requirementservice.printLetter(i) }}.{{ requirementservice.printLetter(subIndex).toLowerCase() }}. {{ sub.title }}</b></div>
                                                <!-- 🔁 Requirements under sub-situation -->
                                                <ng-container *ngFor="let req of sub.requirement; let r = index">
                                                <ng-container
                                                    *ngTemplateOutlet="requirementTree; context: {
                                                    $implicit: req,
                                                    prefix: [
                                                        requirementservice.printLetter(i),
                                                        requirementservice.printLetter(subIndex).toLowerCase(),
                                                        requirementservice.printNumber(r)
                                                    ],
                                                    depth: 3
                                                    }"
                                                ></ng-container>
                                                </ng-container>
                                            </td>
                                        </tr>
                                     </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </td>
                </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </td>
</tr>

    <!-- Recursive Template (no prefix version) -->
<ng-template #requirementTree let-req let-prefix="prefix" let-depth="depth">
    <div class="content-center" style="border-bottom: 0.5px dashed gray;">
        <table class="requirement-table">
            <col style="width:50%" />
            <col style="width:50%" />
            <tbody>
                 <tr *ngIf="!req.chooseany" [id]="'req_' + requirementservice.joinPrefix(prefix)" [ngClass]="'depth-' + depth">
                    <!--First Column-->
                    <td >
                        <span>{{ requirementservice.joinPrefix(prefix) }}. {{ req.requirement }}</span>   
                        <!--First Columns-->
                        <!--Type specific-->
                        <ng-container [ngSwitch]="req.requirementType">
                            <div *ngSwitchCase="'Sample'">({{ req.requirementType }}:
                                {{req.number}} {{req.unit}}) </div>
                            <div *ngSwitchCase="'Documentary'"
                                [innerHtml]="req.documentString"></div>
                            <div *ngSwitchCase="'Id'" [innerHtml]="req.listOfIds"></div>
                        </ng-container>
                        <!--Remarks-->
                            <div class="mt-2" *ngIf="req.remarks_or_reminders != ''">
                                <p class="req-details-header">Remarks:</p>
                                <p [innerHTML]="req.remarks_or_reminders"></p>
                            </div>                                                                            
                    </td>
                    <!--Second Column-->
                    <td>
                        <div *ngIf="!(req.requirementType == 'Id')" class="ms-5">
                            <p *ngIf="!req?.applicant"><span class="req-details-header">Agency - Division: 
                            </span>{{req.agency }} - {{ req.bureau_division }}</p>
                            <p *ngIf="req?.applicant">Applicant / Client</p>
                        </div>
                    </td>
                </tr>
                <!-- SubRequirement --> 
                 <tr *ngIf="req.subRequirement?.length > 0">
                    <td colspan="5">
                          <div class="subsection-highlight"><label class="pl-6">Sub Requirement</label></div>
                            <div class="content-center">
                            <table class="subrequirement-table">
                                <col style="width:50%" />
                                <col style="width:50%" />
                                <tbody>
                                     <ng-container *ngFor="let sub of req.subRequirement; let subIndex = index">
                                        <!-- Sub Req Title -->
                                       <tr [id]="'req_' + requirementservice.joinPrefix(prefix) + '.' + requirementservice.printLetter(subIndex)">

                                            <td colspan="5">
                                                
                                                <div><span *ngIf="sub.title"><i>{{ requirementservice.joinPrefix(prefix) }}.{{ requirementservice.printLetter(subIndex) }}. {{ sub.title }}</i></span></div>
                                                <!-- 🔁 Requirements under sub-situation -->
                                                <ng-container *ngFor="let child of sub.requirement; let childIndex = index">
                                                <ng-container
                                                *ngTemplateOutlet="requirementTree; context: {
                                                    $implicit: child,
                                                    prefix: prefix.concat([requirementservice.printLetter(subIndex), requirementservice.printNumber(childIndex)]),
                                                    depth: depth + 2
                                                }"
                                                ></ng-container>
                                            </ng-container>
                                            </td>
                                        </tr>
                                     </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </td>
                </tr>
                

                <!-- CHOOSE ANY -->
                <tr *ngIf="req.chooseany" [ngClass]="'depth-' + depth" [id]="'req_' + requirementservice.joinPrefix(prefix)">
                    <td colspan="5" [ngStyle]="{ 'padding-left.px': depth * 8 }">
                        <span>{{ requirementservice.joinPrefix(prefix) }}. {{ req.title }}</span>
                        <p class="mx-0"><small>Any of the following:</small></p>
                        <ng-container *ngFor="let opt of req.requirement; let optIndex = index">
                            <ng-container
                            *ngTemplateOutlet="requirementTree; context: {
                                $implicit: opt,
                                prefix: prefix.concat([requirementservice.printLetter(optIndex)]),
                                depth: depth + 1
                            }"
                            ></ng-container>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>


<tr *ngIf="reviewMode && service_effectivity != effectivity.DELIST ">
                <td colspan="5">
                    <div class="container px-5">
                        <h4 *ngIf="openRemarks">Requirements Remarks</h4>
                        <app-artemis-service-remarks-thread [openRemarks]="openRemarks" [remarks]=remarks_thread
                            [service_id]=service_id [component_id]="'Requirements'"
                            [type]="'requirement'"></app-artemis-service-remarks-thread>

                    </div>
                </td>
</tr>
            <tr>
                <td class="row-header text-center">CLIENT STEPS</td>
                <td class="row-header text-center">AGENCY ACTIONS</td>
                <td class="row-header text-center">FEES TO BE PAID</td>
                <td class="row-header text-center">PROCESSING TIME</td>
                <td class="row-header text-center">
                    <div>PERSON RESPONSIBLE</div>
                    <div>(Designation; Office)</div>
                </td>
            </tr>
            <ng-container *ngIf="service.processedClientStep && service.processedClientStep.length > 0">
                <ng-container *ngFor="let clientStep of service.processedClientStep ; let clientStep_Index = index">

                    <ng-container *ngIf="clientStep.situational">

                        <tr *ngIf="clientStep?.step_title " class="client-step">
                            <td colspan="5 w-100">

                                <span class="fw-bold">{{ clientStep.situational_step_title}}</span>

                            </td>

                        </tr>
                        <tr *ngFor="let situationalStep of clientStep.clientStep ; let sitClientStep_Index = index"
                            class="client_step">
                            <ng-container *ngIf="(situationalStep.rowSpan > 0)">
                                <td [id]="situationalStep.step_Id" class="step"
                                    [attr.rowspan]="situationalStep.rowSpan">
                                    <div class="fw-bold mb-1">
                                        {{situationalStep.situation}}
                                    </div>
                                    <div>
                                        {{situationalStep.clientStepName}}
                                    </div>

                                    <label class="fw-bold" for="location mt-1">Location:</label>
                                    <p id="location" class="mt-1 step_loc" [innerHTML]="situationalStep.location"></p>
                                    <!-- <p>Total Fees: {{ clientStep.fees }}</p>-->
                                    <div *ngIf="situationalStep.notes">
                                        <label class="fw-bold" for="nodes">Notes/Instruction: </label>
                                        <p class="step_notes" [innerHTML]="situationalStep.notes">

                                        </p>
                                    </div>
                                    <div class="container"
                                        *ngIf="reviewMode && service_effectivity != effectivity.DELIST ">


                                        <app-artemis-service-remarks-thread [openRemarks]="openRemarks"
                                            [remarks]=remarks_thread [service_id]=service_id
                                            [component_id]="situationalStep.step_Id"
                                            [type]="client_Step"></app-artemis-service-remarks-thread>


                                    </div>


                                </td>
                            </ng-container>
                            <td [id]="situationalStep.action_Id" class="step">
                                <!--removed situational step title in agency action
                                  <div *ngIf="clientStep.isSituationalStep == true" class="situational-header">* If {{clientStep.situation}}</div>-->
                                <div>{{situationalStep.agencyActions}}</div>
                                <div class="container" *ngIf="reviewMode && service_effectivity != effectivity.DELIST ">

                                    <app-artemis-service-remarks-thread [openRemarks]="openRemarks"
                                        [remarks]=remarks_thread [service_id]=service_id
                                        [component_id]="situationalStep.action_Id"
                                        [type]="agency_action"></app-artemis-service-remarks-thread>


                                </div>
                            </td>
                            <ng-container *ngIf="(situationalStep.rowSpan > 0)">
                                <td [attr.rowspan]="situationalStep.rowSpan">
                                    <p [innerHTML]="situationalStep.fees"></p>

                                    <!--  <div *ngIf="(situationalStep.formulaFeesArr.length > 0 || situationalStep.possibleFeesArr.length > 0) " >
                                  <div *ngIf="situationalStep?.fees != 'None'" >
                                      <ul style="list-style-type: none;">
                                          
                                          <li *ngFor="let fee of computeTotalFees([ ],situational_clientStep(clientStep_Index,sitClientStep_Index))">
                                             + {{fee.currency}} {{fee.amount  }} 
                                          </li>
                                          <li *ngIf="(clientStep.formulaFeesArr.length > 0 || clientStep.possibleFeesArr.length > 0)">
                                              Plus
                                          </li>
                                      </ul> 
                                    
                                    </div>
                                  <div *ngIf="situationalStep.formulaFeesArr.length > 0">
                                    <div>
                                      <ul>
                                          <li style="cursor: pointer; font-style: italic;" (click)="openFees(sfee)" *ngFor="let sfee of situationalStep.formulaFeesArr">
                                              {{sfee.fee_type}}
                                          </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div *ngIf="situationalStep.possibleFeesArr.length > 0">
                                    <div>
                                      <ul>
                                          <li style="cursor: pointer; font-style: italic;" (click)="openFees(sfee)" *ngFor="let sfee of situationalStep.possibleFeesArr">
                                              {{sfee.fee_type}}
                                          </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
  
                                <ul style="list-style-type: none;">
                                  <ng-container *ngIf="computeTotalFees([],situational_clientStep(clientStep_Index,sitClientStep_Index)).length ; else noFee">
                                      <li *ngFor="let fee of computeTotalFees([],situational_clientStep(clientStep_Index,sitClientStep_Index))">
                                          + {{fee.currency}} {{fee.amount  }} 
                                       </li>
                                  </ng-container>
                                </ul>  -->



                                    <!-- <div *ngIf="(situationalStep.formulaFeesArr.length <= 0 && situationalStep.possibleFeesArr.length <= 0) " [innerHtml]="situationalStep.fees"></div>
                            -->
                                </td>
                            </ng-container>
                            <td class="text-center"><span
                                    style="vertical-align: middle;">{{situationalStep.calendardaysTime}}
                                    {{situationalStep.processingTime}}</span>
                                <div class="container" *ngIf="reviewMode && service_effectivity != effectivity.DELIST ">

                                    <app-artemis-service-remarks-thread [openRemarks]="openRemarks"
                                        [remarks]=remarks_thread [service_id]=service_id
                                        [component_id]="situationalStep.action_Id"
                                        [type]="'ProcessingTime'"></app-artemis-service-remarks-thread>


                                </div>
                            </td>
                            <td >
                                <ul class="wrapper">
                                    <ng-container *ngFor="let personResponsible of situationalStep.personResponsible">
                                        <li>
                                            {{personResponsible.designation}}; {{personResponsible.division_group?.name
                                            ? personResponsible.division_group.name : personResponsible.division_group
                                            }}
                                        </li>
                                    </ng-container>
                                </ul>

                                <div class="container" *ngIf="reviewMode && service_effectivity != effectivity.DELIST ">

                                    <app-artemis-service-remarks-thread [openRemarks]="openRemarks"
                                        [remarks]=remarks_thread [service_id]=service_id
                                        [component_id]="situationalStep.action_Id"
                                        [type]="'PersonResponsible'"></app-artemis-service-remarks-thread>


                                </div>
                            </td>
                        </tr>
                    </ng-container>

                    <ng-container *ngIf="!clientStep.situational">

                        <tr class="client_step">
                            <ng-container *ngIf="(clientStep.rowSpan > 0)">
                                <td [id]="clientStep.step_Id" class="step" [attr.rowspan]="clientStep.rowSpan">
                                    <div *ngIf="clientStep.isSituationalStep == true" class="situational-header">*For
                                        {{clientStep.situation}}</div>
                                    {{clientStep.clientStepName}}
                                    <br>
                                    <label class="fw-bold" for="location mt-1">Location:</label>
                                    <p id="location" class="mt-1 step_loc" [innerHTML]="clientStep.location"></p>
                                    <div *ngIf="clientStep.notes">
                                        <label class="fw-bold" for="nodes">Notes/Instruction: </label>
                                        <p class="step_notes" [innerHTML]="clientStep.notes">

                                        </p>
                                    </div>
                                    <div class="container"
                                        *ngIf="reviewMode && service_effectivity != effectivity.DELIST ">
                                        <app-artemis-service-remarks-thread [openRemarks]="openRemarks"
                                            [remarks]=remarks_thread [service_id]=service_id
                                            [component_id]="clientStep.step_Id"
                                            [type]="client_Step"></app-artemis-service-remarks-thread>
                                    </div>
                                </td>
                            </ng-container>
                            <td [id]="clientStep.action_Id" class="step">
                                <!--removed situational step title in agency action
                                  <div *ngIf="clientStep.isSituationalStep == true" class="situational-header">* If {{clientStep.situation}}</div>-->
                                <div>{{clientStep.agencyActions}}</div>
                                <div class="container" *ngIf="reviewMode && service_effectivity != effectivity.DELIST ">

                                    <app-artemis-service-remarks-thread [openRemarks]="openRemarks"
                                        [remarks]=remarks_thread [service_id]=service_id
                                        [component_id]="clientStep.action_Id"
                                        [type]="agency_action"></app-artemis-service-remarks-thread>


                                </div>
                            </td>
                            <ng-container *ngIf="(clientStep.rowSpan > 0)">
                                <td [attr.rowspan]="clientStep.rowSpan">
                                    <p [innerHTML]="clientStep.fees"></p>

                                    <!--   <div *ngIf="(clientStep.formulaFeesArr.length > 0 || clientStep.possibleFeesArr.length > 0) " >
                                    <div *ngIf="clientStep?.fees != 'None'" >
                                      <ul style="list-style-type: none;">
                                          <li *ngFor="let fee of computeTotalFees([service.clientSteps[clientStep_Index]])">
                                             + {{fee.currency}} {{fee.amount  }} 
                                          </li>
                                          <li *ngIf="(clientStep.formulaFeesArr.length > 0 || clientStep.possibleFeesArr.length > 0)">
                                              Plus
                                          </li>
                                      </ul> 
        
                                    </div>
                                  <div *ngIf="clientStep.formulaFeesArr.length > 0">
                                      <div>
                                        <ul>
                                            <li style="cursor: pointer; font-style: italic;" (click)="openFees(sfee)" *ngFor="let sfee of clientStep.formulaFeesArr">
                                                {{sfee.fee_type}}
                                            </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div *ngIf="clientStep.possibleFeesArr.length > 0">
                                      <div >
                                        <ul>
                                            <li style="cursor: pointer; font-style: italic;" (click)="openFees(sfee)" *ngFor="let sfee of clientStep.possibleFeesArr">
                                                {{sfee.fee_type}}
                                            </li>
                                        </ul>
                                      </div>
                                    </div>
                                </div>
        
                                <div class="text-center" *ngIf="(clientStep.formulaFeesArr.length <= 0 && clientStep.possibleFeesArr.length <= 0) ">
                                  <ul style="list-style-type: none;">
                                      <li *ngFor="let fee of computeTotalFees([service.clientSteps[clientStep_Index]])">
                                         + {{fee.currency}} {{fee.amount  }} 
                                      </li>
                                  </ul> 
  
                                  <ng-container *ngIf="!computeTotalFees([service.clientSteps[clientStep_Index]]).length">
                                      None
                                  </ng-container>
    
                                </div> -->
                                </td>
                            </ng-container>
                            <td class="text-center"><span>{{clientStep.calendardaysTime}}
                                    {{clientStep.processingTime}}</span>
                                <div class="container" *ngIf="reviewMode && service_effectivity != effectivity.DELIST ">

                                    <app-artemis-service-remarks-thread [openRemarks]="openRemarks"
                                        [remarks]=remarks_thread [service_id]=service_id
                                        [component_id]="clientStep.action_Id"
                                        [type]="'ProcessingTime'"></app-artemis-service-remarks-thread>


                                </div>
                            </td>
                            <td>
                                <ul>
                                    <ng-container *ngFor="let personResponsible of clientStep.personResponsible">
                                        <li>
                                            {{personResponsible.designation}}; {{personResponsible.division_group?.name
                                            ? personResponsible.division_group.name : personResponsible.division_group
                                            }}
                                        </li>
                                    </ng-container>
                                </ul>

                                <div class="container" *ngIf="reviewMode && service_effectivity != effectivity.DELIST ">

                                    <app-artemis-service-remarks-thread [openRemarks]="openRemarks"
                                        [remarks]=remarks_thread [service_id]=service_id
                                        [component_id]="clientStep.action_Id"
                                        [type]="'PersonResponsible'"></app-artemis-service-remarks-thread>


                                </div>
                            </td>
                        </tr>

                    </ng-container>


                </ng-container>
            </ng-container>
            <tr *ngIf="service.serviceDetails?.general_remarks">
                <td colspan="5">
                    <label class="text-bold" for="generalremarks">General Remarks</label>
                    <div id="generalremarks" [innerHTML]=" service.serviceDetails?.general_remarks"></div>
                </td>
            </tr>
            <tr *ngIf="situational_steps.length > 0">
                <th colspan="5" class="text-center header-details">Total Processing Time:</th>
            </tr>
            <tr *ngIf="situational_steps.length <= 0">
                <th colspan="2" class="text-center header-details">Total Processing Time:</th>
                <td id="tpt" colspan="3" class="text-start"><span [innerHTML]="computeProcessingTime(service.clientSteps)"></span></td>
            </tr>
            <tr *ngFor="let sit_step of situational_steps">
                <td colspan="2" class="text-center row-header">*For {{sit_step.info.situation}}</td>
                <td id="tpt" colspan="3" class="text-start"><span
                        [innerHTML]="computeProcessingTime(service.clientSteps, sit_step)"></span>
                </td>
            </tr>
            <tr *ngIf="situational_steps.length === 0">
                <th colspan="2" class="text-center header-details">Total Processing Fee:</th>
                <td id="tpf" colspan="3" class="text-start">
                    <div>
                        <div>
                            <p> {{computeTotalFees(service.clientSteps).length > 0 ?'Total Standard Fee:':'Total
                                Standard Fee: None'}} </p>
                            <ul style="list-style-type: none;">
                                <li *ngFor="let fee of computeTotalFees(service.clientSteps)">
                                    {{fee.currency}} {{fee.amount }}
                                </li>
                            </ul>
                        </div>

                        <p class=" m-0 p-0"
                                *ngIf="filterPossibleFees(service.clientSteps).length > 0 || filterPossibleFees(situational_steps).length > 0 || filterFormulaFees(service.clientSteps).length > 0 || filterFormulaFees(situational_steps).length > 0 ">
                                See other fees below</p>



                        <!--<ng-container
                            *ngIf="!computeTotalFees(service.clientSteps).length  && (!service?.countStepwithFormula && !service?.countStepwithPossible)">
                            None
                        </ng-container> -->
                    </div>
                </td>
            </tr>
            <ng-container *ngIf="situational_steps.length > 0">
                <tr>
                    <th colspan="5" class="text-center header-details">Total Processing Fee:</th>
                </tr>
                <tr *ngFor="let sit_step of situational_steps">
                    <td colspan="2" class="text-center row-header">*For {{sit_step.info.situation}}</td>
                    <td id="tpt" colspan="3" class="text-start">
                        <ng-container>
                            <p class=" m-0 p-0">{{computeTotalFees(service.clientSteps,sit_step).length > 0 ?'Total
                                Standard Fee:':'Total Standard Fee: None'}} </p>
            
                            <ul style="list-style-type: none;margin:0;">
                                <li *ngFor="let fee of computeTotalFees(service.clientSteps,sit_step)">
                                    <span> {{fee.currency}} {{fee.amount }} </span>
                                </li>
                            </ul>
                            <p class=" m-0 p-0"
                                *ngIf="filterPossibleFees(service.clientSteps).length > 0 || filterPossibleFees(situational_steps).length > 0 || filterFormulaFees(service.clientSteps).length > 0 || filterFormulaFees(situational_steps).length > 0 ">
                                See other fees below</p>

                            <!--<ng-container
                                *ngIf="!computeTotalFees(service.clientSteps).length && (!service?.countStepwithFormula && !service?.countStepwithPossible)">
                                None
                            </ng-container>-->
                        </ng-container>

                        <!--  <ul style="list-style-type: none;">
                          <li *ngFor="let fee of computeTotalFees(service.clientSteps,sit_step)">
                             Standard Fee: {{fee.currency}} {{fee.amount  }} 
                          </li>
                          
                      </ul> -->
                        <!--  <ng-container
                            *ngIf="!computeTotalFees(service.clientSteps,sit_step).length && (!sit_step.info.list_of_formula_fees && !sit_step.list_of_possible_fees )">
                            None
                        </ng-container>-->
                        <ng-container>
                            <!--  <p class="m-0 p-0 fw-bold"
                                *ngIf="sit_step.info.list_of_possible_fees || sit_step.info.list_of_formula_fees">
                                Additional
                                Situation Fees:
                            </p> -->
                            <!--   <div *ngIf="sit_step.info.list_of_possible_fees">
                                <div>
                                    <ul style="list-style-type:none;margin: 0;">
                                        <li style="cursor: pointer; " (click)="openFees(sfee)"
                                            *ngFor="let sfee of sit_step.info.list_of_possible_fees_arr">
                                            + <span class="">{{sfee.fee_type}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div *ngIf="sit_step.info.list_of_formula_fees">
                                <div>
                                    <ul style="list-style-type:none;margin: 0;">
                                        <li style="cursor: pointer; " (click)="openFees(sfee)"
                                            *ngFor="let sfee of sit_step.info.list_of_formula_fees_arr">
                                            + <span class="">{{sfee.fee_type}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div> -->
                        </ng-container>
                    </td>
                </tr>
            </ng-container>
            <tr *ngIf="filterPossibleFees(service.clientSteps).length > 0 || filterPossibleFees(situational_steps).length > 0">
                <td id="lpf" colspan="5">
                    <label for="">Possible Fees</label>
                    <ul class="mb-1">
                        <div *ngFor="let clientstep of filterPossibleFees(service.clientSteps) ">
                            <strong class="fw-bold">{{clientstep.fee_type}}</strong> : {{ clientstep.amount }}
                        </div>

                        <div *ngFor="let clientstep of filterPossibleFees(situational_steps) ">
                            <label for="">{{clientstep?.situation}}</label>
                            <strong class="fw-bold">{{clientstep.fee_type}}</strong> : {{ clientstep.amount }}
                        </div>
                    </ul>
                </td>
            </tr>
            <tr *ngIf="filterFormulaFees(service.clientSteps).length > 0 || filterFormulaFees(situational_steps).length > 0 ">
                <td id="lff" colspan="5">
                    <label for="">Formula / Schedule of Fees</label>
                    <ul>
                        <div *ngFor="let clientstep of filterFormulaFees(service.clientSteps) ">

                            <p><strong class="fw-bold">{{clientstep.fee_type}} </strong></p>
                            <div class="mce-content-body" [innerHTML]="sanitizeFormulafees(clientstep.amount) "></div>

                        </div>
                        <div *ngFor="let clientstep of filterFormulaFees(situational_steps) ">
                            <label for="">{{client_Step?.situation}}</label>
                            <p><strong class="fw-bold">{{clientstep.fee_type}} </strong></p>
                            <div class="mce-content-body" [innerHTML]="sanitizeFormulafees(clientstep.amount)"></div>

                        </div>
                    </ul>

                </td>
            </tr>
        </tbody>
    </table>

    <div class="row container px-5" *ngIf="reviewMode ">
        <h4 class="mt-2">General Remarks</h4>
        <app-artemis-service-remarks-thread [openRemarks]="openRemarks" [remarks]=remarks_thread [service_id]=service_id
            [component_id]="'General_Remarks'" [type]="'general_remarks'"></app-artemis-service-remarks-thread>
    </div>

    <div *ngIf="group_office.length" class="row container px-5">
        <h4 class="mt-2">Office Legend</h4>
        <ul [id]="officegroup.name" *ngFor="let officegroup of group_office">
            <label for="">{{officegroup.name}}</label>
            <li *ngFor="let office of officegroup.offices">
                {{office.name}}
            </li>
        </ul>
    </div>
    <div class="row container px-5" *ngIf="reviewMode && service_effectivity != effectivity.DELIST ">
        <h4 class="mt-2">Service EODB Tags Remarks</h4>
        <app-artemis-service-remarks-thread [openRemarks]="openRemarks" [remarks]=remarks_thread [service_id]=service_id
            [component_id]="'EODB_Tags'" [type]="'eodb_tags'"></app-artemis-service-remarks-thread>

    </div>
</div>
<ng-template #noFee>
    None
</ng-template>

<div class="page-break"></div>  